/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext'
import { getRequestOptions } from '../helpers/Fetchwrapper'
import clsx from 'clsx'

const PaymentList = () => {
    const { currentUser } = useContext(AppContext)
    const [payments, setPayments] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [filterStatus, setFilterStatus] = useState('all')
    const [filterPaymentType, setFilterPaymentType] = useState('all')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [selectedPayment, setSelectedPayment] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0,
        has_next_page: false,
        has_prev_page: false,
        from: 0,
        to: 0
    })

    useEffect(() => {
        fetchPayments()
    }, [currentPage, searchTerm, filterStatus, filterPaymentType, itemsPerPage])

    const fetchPayments = () => {
        setLoading(true)
        
        // Build query parameters
        const params = new URLSearchParams({
            page: currentPage.toString(),
            per_page: itemsPerPage.toString(),
            search: searchTerm,
            status: filterStatus,
            payment_type: filterPaymentType,
            sort_by: 'create_date',
            sort_order: 'desc'
        })

        fetch(process.env.REACT_APP_API_URL + "payment_list?" + params.toString(), getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setPayments(resp.data || [])
                    setPagination(resp.pagination || {
                        current_page: 1,
                        per_page: 10,
                        total: 0,
                        total_pages: 0,
                        has_next_page: false,
                        has_prev_page: false,
                        from: 0,
                        to: 0
                    })
                } else {
                    console.error('Failed to fetch payments:', resp.errorMessage || resp.message)
                    setPayments([])
                }
            })
            .catch((error) => {
                console.error('Error fetching payments:', error)
                setPayments([])
            })
            .finally(() => {
                setLoading(false)
            })
    }

    // Handle search with debounce
    const [searchDebounceTimer, setSearchDebounceTimer] = useState(null)
    
    const handleSearchChange = (value) => {
        setSearchTerm(value)
        
        // Clear previous timer
        if (searchDebounceTimer) {
            clearTimeout(searchDebounceTimer)
        }
        
        // Set new timer for debounced search
        const timer = setTimeout(() => {
            setCurrentPage(1) // Reset to first page when searching
        }, 500)
        
        setSearchDebounceTimer(timer)
    }

    const handleFilterChange = (type, value) => {
        if (type === 'status') {
            setFilterStatus(value)
        } else if (type === 'paymentType') {
            setFilterPaymentType(value)
        } else if (type === 'perPage') {
            setItemsPerPage(parseInt(value))
        }
        setCurrentPage(1) // Reset to first page when filtering
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const getStatusBadge = (status) => {
        switch (status?.toLowerCase()) {
            case 'created':
                return 'bg-warning text-dark'
            case 'approved':
                return 'bg-success'
            case 'pending':
                return 'bg-warning text-dark'
            case 'verified':
                return 'bg-success'
            case 'rejected':
                return 'bg-danger'
            case 'processing':
                return 'bg-info'
            default:
                return 'bg-secondary'
        }
    }

    const getPaymentTypeBadge = (paymentType) => {
        switch (paymentType?.toLowerCase()) {
            case 'bkash':
                return 'bg-pink text-white'
            case 'nagad':
                return 'bg-orange text-white'
            case 'rocket':
                return 'bg-purple text-white'
            case 'city-bank':
                return 'bg-primary'
            case 'eastern-bank':
                return 'bg-success'
            case 'islami-bank':
                return 'bg-info'
            default:
                return 'bg-secondary'
        }
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A'
        const date = new Date(dateString)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('en-BD', {
            style: 'currency',
            currency: 'BDT',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(amount || 0)
    }

    const viewPaymentDetails = (payment) => {
        
        setSelectedPayment(payment)
        setShowModal(true)
    }

    const refreshPayments = () => {
        setCurrentPage(1)
        setSearchTerm('')
        setFilterStatus('all')
        setFilterPaymentType('all')
        fetchPayments()
    }

    const updatePaymentStatus = (paymentId, newStatus) => {
        return fetch(process.env.REACT_APP_API_URL + `payment_status_update/${paymentId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getRequestOptions().headers
            },
            body: JSON.stringify({ status: newStatus })
        })
        .then(response => response.json())
    }

    const approvePayment = async (payment) => {
        try {
            setLoading(true)
            const response = await updatePaymentStatus(payment.id, 'approved')
            
            if (response.success) {
                // Update the payment in the list
                setPayments(payments.map(p => 
                    p.id === payment.id 
                        ? { ...p, status: 'approved' }
                        : p
                ))
                
                // Update selected payment if it's the same one
                if (selectedPayment && selectedPayment.id === payment.id) {
                    setSelectedPayment({ ...selectedPayment, status: 'approved' })
                }
                
                // Show success message (you can replace this with a toast notification)
                alert('Payment approved successfully!')
            } else {
                alert('Failed to approve payment: ' + (response.errorMessage || response.message))
            }
        } catch (error) {
            console.error('Error approving payment:', error)
            alert('Error approving payment. Please try again.')
        } finally {
            setLoading(false)
        }
    }



    // Cleanup debounce timer on unmount
    useEffect(() => {
        return () => {
            if (searchDebounceTimer) {
                clearTimeout(searchDebounceTimer)
            }
        }
    }, [searchDebounceTimer])

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className='card-title'>
                        <h3 className='card-label'>Payment List</h3>
                    </div>
                    <div className='card-toolbar'>
                        <button 
                            className='btn btn-primary btn-sm'
                            onClick={refreshPayments}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Loading...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-sync-alt"></i> Refresh
                                </>
                            )}
                        </button>
                    </div>
                </div>

                <div className='card-body'>
                    {/* Filters */}
                    <div className='filters-container mb-4'>
                        {/* Mobile Filters */}
                        <div className='d-lg-none'>
                            <div className='row g-2'>
                                <div className='col-12'>
                                    <div className="position-relative">
                                        <input
                                            type='text'
                                            className='form-control form-control-lg'
                                            placeholder='Search payments...'
                                            value={searchTerm}
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            
                                        />
                                        <div className="position-absolute top-50 start-0 translate-middle-y ms-3">
                                            <i className="fas fa-search text-muted"></i>
                                        </div>
                                        {loading && (
                                            <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Searching...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <select
                                        className='form-select'
                                        value={filterStatus}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Status</option>
                                        <option value='created'>Created</option>
                                        <option value='approved'>Approved</option>
                                        <option value='pending'>Pending</option>
                                        <option value='verified'>Verified</option>
                                        <option value='rejected'>Rejected</option>
                                        <option value='processing'>Processing</option>
                                    </select>
                                </div>
                                <div className='col-6'>
                                    <select
                                        className='form-select'
                                        value={filterPaymentType}
                                        onChange={(e) => handleFilterChange('paymentType', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Types</option>
                                        <option value='bkash'>bKash</option>
                                        <option value='nagad'>Nagad</option>
                                        <option value='rocket'>Rocket</option>
                                        <option value='city-bank'>City Bank</option>
                                        <option value='eastern-bank'>Eastern Bank</option>
                                        <option value='islami-bank'>Islami Bank</option>
                                    </select>
                                </div>
                                <div className='col-12'>
                                    <select
                                        className='form-select'
                                        value={itemsPerPage}
                                        onChange={(e) => handleFilterChange('perPage', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value={10}>Show 10 payments</option>
                                        <option value={20}>Show 20 payments</option>
                                        <option value={50}>Show 50 payments</option>
                                        <option value={100}>Show 100 payments</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Desktop Filters */}
                        <div className='d-none d-lg-block'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className="position-relative">
                                        <input
                                            type='text'
                                            className='form-control'
                                            placeholder='Search by reference, transaction ID, order ID, or mobile...'
                                            value={searchTerm}
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            disabled={loading}
                                        />
                                        {loading && (
                                            <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Searching...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <select
                                        className='form-select'
                                        value={filterStatus}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Status</option>
                                        <option value='created'>Created</option>
                                        <option value='approved'>Approved</option>
                                        <option value='pending'>Pending</option>
                                        <option value='verified'>Verified</option>
                                        <option value='rejected'>Rejected</option>
                                        <option value='processing'>Processing</option>
                                    </select>
                                </div>
                                <div className='col-md-3'>
                                    <select
                                        className='form-select'
                                        value={filterPaymentType}
                                        onChange={(e) => handleFilterChange('paymentType', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Payment Types</option>
                                        <option value='bkash'>bKash</option>
                                        <option value='nagad'>Nagad</option>
                                        <option value='rocket'>Rocket</option>
                                        <option value='city-bank'>City Bank</option>
                                        <option value='eastern-bank'>Eastern Bank</option>
                                        <option value='islami-bank'>Islami Bank</option>
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <select
                                        className='form-select'
                                        value={itemsPerPage}
                                        onChange={(e) => handleFilterChange('perPage', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value={10}>10 per page</option>
                                        <option value={20}>20 per page</option>
                                        <option value={50}>50 per page</option>
                                        <option value={100}>100 per page</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Results Summary */}
                    <div className='row mb-3'>
                        <div className='col-12'>
                            <div className='text-muted small'>
                                {pagination.total > 0 ? (
                                    <>
                                        Showing {pagination.from}-{pagination.to} of {pagination.total} payments
                                    </>
                                ) : (
                                    'No payments found'
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Payment List - Desktop Table / Mobile Cards */}
                    <div className='payment-list-container'>
                        {/* Desktop Table View */}
                        <div className='d-none d-lg-block'>
                            <div className='table-responsive'>
                                <table className='table table-striped table-hover'>
                                    <thead className='table-dark'>
                                        <tr>
                                            <th>Reference</th>
                                            <th>Order/Bill ID</th>
                                            <th>Amount</th>
                                            <th>Payment Type</th>
                                            <th>Method</th>
                                            <th>Transaction ID</th>
                                            <th>Status</th>
                                            <th>Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan='9' className='text-center py-4'>
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <p className="mt-2">Loading payments...</p>
                                                </td>
                                            </tr>
                                        ) : payments.length === 0 ? (
                                            <tr>
                                                <td colSpan='9' className='text-center py-4'>
                                                    <div className='text-muted'>
                                                        <i className='fas fa-credit-card fa-3x mb-3'></i>
                                                        <p>No payments found</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            payments.map((payment, index) => (
                                                <tr key={payment.id || index}>
                                                    <td>
                                                        <span className='text-truncate' style={{maxWidth: '150px', display: 'inline-block'}}>
                                                            {payment.reference || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>{payment.orderId || 'N/A'}</td>
                                                    <td className='fw-bold text-success'>
                                                        {formatAmount(payment.amount)}
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${getPaymentTypeBadge(payment.paymentType)}`}>
                                                            {payment.paymentType || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className='badge bg-light text-dark'>
                                                            {payment.modeOfTransaction || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className='text-truncate' style={{maxWidth: '120px', display: 'inline-block'}}>
                                                            {payment.transactionId || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${getStatusBadge(payment.status)}`}>
                                                            {payment.status || 'Pending'}
                                                        </span>
                                                    </td>
                                                    <td className='text-nowrap'>
                                                        {formatDate(payment.createdAt || payment.created_at)}
                                                    </td>
                                                    <td>
                                                        <button
                                                            className='btn btn-sm btn-outline-primary'
                                                            onClick={() => viewPaymentDetails(payment)}
                                                            title='View Details'
                                                        >
                                                            <i className='fas fa-eye'></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Mobile Card View */}
                        <div className='d-lg-none'>
                            {loading ? (
                                <div className='text-center py-5'>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2">Loading payments...</p>
                                </div>
                            ) : payments.length === 0 ? (
                                <div className='text-center py-5'>
                                    <div className='text-muted'>
                                        <i className='fas fa-credit-card fa-3x mb-3'></i>
                                        <p>No payments found</p>
                                    </div>
                                </div>
                            ) : (
                                <div className='payment-cards'>
                                    {payments.map((payment, index) => (
                                        <div 
                                            key={payment.id || index} 
                                            className='payment-card'
                                            onClick={() => viewPaymentDetails(payment)}
                                        >
                                            <div className='payment-card-header'>
                                                <div className='payment-amount'>
                                                    {formatAmount(payment.amount)}
                                                </div>
                                                <div className='payment-status'>
                                                    <span className={`badge ${getStatusBadge(payment.status)}`}>
                                                        {payment.status || 'Pending'}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className='payment-card-body'>
                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-tag me-2'></i>Reference:
                                                    </span>
                                                    <span className='info-value-mobile font-monospace'>
                                                        {payment.reference || 'N/A'}
                                                    </span>
                                                </div>
                                                
                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-hashtag me-2'></i>Order ID:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        {payment.orderId || 'N/A'}
                                                    </span>
                                                </div>
                                                
                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-university me-2'></i>Payment Type:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        <span className={`badge ${getPaymentTypeBadge(payment.paymentType)}`}>
                                                            {payment.paymentType || 'N/A'}
                                                        </span>
                                                    </span>
                                                </div>
                                                
                                                {payment.transactionId && (
                                                    <div className='payment-info-row'>
                                                        <span className='info-label-mobile'>
                                                            <i className='fas fa-barcode me-2'></i>Transaction ID:
                                                        </span>
                                                        <span className='info-value-mobile font-monospace'>
                                                            {payment.transactionId}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            
                                            <div className='payment-card-footer'>
                                                <div className='payment-date'>
                                                    <i className='fas fa-calendar me-2 text-muted'></i>
                                                    <small className='text-muted'>
                                                        {formatDate(payment.createdAt || payment.created_at)}
                                                    </small>
                                                </div>
                                                <div className='payment-action'>
                                                    <i className='fas fa-chevron-right text-primary'></i>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Pagination */}
                    {pagination.total_pages > 1 && (
                        <div className='d-flex justify-content-between align-items-center mt-4'>
                            <div className='text-muted small'>
                                Page {pagination.current_page} of {pagination.total_pages}
                            </div>
                            <nav>
                                <ul className='pagination mb-0'>
                                    <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(1)}
                                            disabled={!pagination.has_prev_page}
                                            title="First Page"
                                        >
                                            <i className="fas fa-angle-double-left"></i>
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.current_page - 1)}
                                            disabled={!pagination.has_prev_page}
                                        >
                                            <i className="fas fa-angle-left"></i> Previous
                                        </button>
                                    </li>
                                    
                                    {/* Page Numbers */}
                                    {(() => {
                                        const pages = [];
                                        const current = pagination.current_page;
                                        const total = pagination.total_pages;
                                        const maxVisible = 5;
                                        
                                        let start = Math.max(1, current - Math.floor(maxVisible / 2));
                                        let end = Math.min(total, start + maxVisible - 1);
                                        
                                        if (end - start < maxVisible - 1) {
                                            start = Math.max(1, end - maxVisible + 1);
                                        }
                                        
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                                <li key={i} className={`page-item ${current === i ? 'active' : ''}`}>
                                                    <button
                                                        className='page-link'
                                                        onClick={() => handlePageChange(i)}
                                                    >
                                                        {i}
                                                    </button>
                                                </li>
                                            );
                                        }
                                        return pages;
                                    })()}
                                    
                                    <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.current_page + 1)}
                                            disabled={!pagination.has_next_page}
                                        >
                                            Next <i className="fas fa-angle-right"></i>
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.total_pages)}
                                            disabled={!pagination.has_next_page}
                                            title="Last Page"
                                        >
                                            <i className="fas fa-angle-double-right"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                </div>
            </div>

            {/* Payment Details Modal */}
            {showModal && selectedPayment && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)'}} onClick={() => setShowModal(false)}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <div>
                                    <h4 className='modal-title mb-0'>
                                        <i className='fas fa-receipt me-2 text-primary'></i>
                                        Payment Details
                                    </h4>
                                </div>
                                <button
                                    type='button'
                                    className='btn-close'
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className='modal-body p-4 modal-body-scrollable'>
                                {/* Payment Status Banner */}
                                <div className='row mb-4'>
                                    <div className='col-12'>
                                        <div className='card border-0 bg-light'>
                                            <div className='card-body text-center py-3'>
                                                <h2 className='text-success mb-2'>{formatAmount(selectedPayment.amount)}</h2>
                                                <span className={`badge fs-6 px-3 py-2 ${getStatusBadge(selectedPayment.status)}`}>
                                                    <i className='fas fa-info-circle me-1'></i>
                                                    {selectedPayment.status || 'Pending'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    {/* Left Column - Payment Information */}
                                    <div className='col-lg-8'>
                                        <div className='card border-0 shadow-sm mb-4'>
                                            <div className='card-header bg-white'>
                                                <h6 className='card-title mb-0'>
                                                    <i className='fas fa-credit-card text-primary me-2'></i>
                                                    Payment Information
                                                </h6>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row g-3'>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-tag text-muted me-2'></i>
                                                                Reference:
                                                            </span>
                                                            <span className='info-value-inline font-monospace'>{selectedPayment.reference || 'N/A'}</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-hashtag text-muted me-2'></i>
                                                                Order/Bill ID:
                                                            </span>
                                                            <span className='info-value-inline'>{selectedPayment.orderId || 'N/A'}</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-file-invoice text-muted me-2'></i>
                                                                Invoice ID:
                                                            </span>
                                                            <span className='info-value-inline'>{selectedPayment.invoiceId || 'N/A'}</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-university text-muted me-2'></i>
                                                                Payment Type:
                                                            </span>
                                                            <span className='info-value-inline'>
                                                                <span className={`badge ${getPaymentTypeBadge(selectedPayment.paymentType)}`}>
                                                                    {selectedPayment.paymentType || 'N/A'}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-exchange-alt text-muted me-2'></i>
                                                                Transaction Method:
                                                            </span>
                                                            <span className='info-value-inline'>
                                                                <span className='badge bg-light text-dark border'>
                                                                    {selectedPayment.modeOfTransaction || 'N/A'}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-barcode text-muted me-2'></i>
                                                                Transaction ID:
                                                            </span>
                                                            <span className='info-value-inline font-monospace'>
                                                                {selectedPayment.transactionId || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='info-item-inline'>
                                                            <span className='info-label-inline'>
                                                                <i className='fas fa-calendar text-muted me-2'></i>
                                                                Payment Date:
                                                            </span>
                                                            <span className='info-value-inline'>
                                                                {formatDate(selectedPayment.createdAt || selectedPayment.created_at)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {selectedPayment.paymentCategory && (
                                                        <div className='col-md-6'>
                                                            <div className='info-item-inline'>
                                                                <span className='info-label-inline'>
                                                                    <i className='fas fa-tags text-muted me-2'></i>
                                                                    Payment Category:
                                                                </span>
                                                                <span className='info-value-inline'>
                                                                    <span className='badge bg-info text-white'>
                                                                        {selectedPayment.paymentCategory}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {selectedPayment.customerName && (
                                                        <div className='col-md-6'>
                                                            <div className='info-item-inline'>
                                                                <span className='info-label-inline'>
                                                                    <i className='fas fa-user text-muted me-2'></i>
                                                                    Customer Name:
                                                                </span>
                                                                <span className='info-value-inline'>{selectedPayment.customerName}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {selectedPayment.mobileNumber && (
                                                        <div className='col-md-6'>
                                                            <div className='info-item-inline'>
                                                                <span className='info-label-inline'>
                                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                                    Mobile Number:
                                                                </span>
                                                                <span className='info-value-inline font-monospace'>{selectedPayment.mobileNumber}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {selectedPayment.notes && (
                                                        <div className='col-12'>
                                                            <div className='info-item-inline'>
                                                                <span className='info-label-inline'>
                                                                    <i className='fas fa-sticky-note text-muted me-2'></i>
                                                                    Notes:
                                                                </span>
                                                                <span className='info-value-inline notes-inline'>
                                                                    {selectedPayment.notes}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                    {/* Right Column - Payment Proof */}
                                    <div className='col-lg-4'>
                                        {selectedPayment.files ? (
                                            <div className='card border-0 shadow-sm'>
                                                <div className='card-header bg-white'>
                                                    <h6 className='card-title mb-0'>
                                                        <i className='fas fa-image text-success me-2'></i>
                                                        Payment Proof
                                                    </h6>
                                                </div>
                                                <div className='card-body p-0'>
                                                    <div className='payment-image-container position-relative'>
                                                        <img 
                                                            src={selectedPayment.files} 
                                                            alt='Payment Proof' 
                                                            className='payment-image w-100'
                                                            style={{
                                                                maxHeight: '300px',
                                                                objectFit: 'contain',
                                                                backgroundColor: '#f8f9fa'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.style.display = 'none';
                                                                e.target.nextSibling.style.display = 'block';
                                                            }}
                                                        />
                                                        <div 
                                                            className='text-center p-4 text-muted'
                                                            style={{display: 'none'}}
                                                        >
                                                            <i className='fas fa-image fa-3x mb-3 opacity-50'></i>
                                                            <p>Image could not be loaded</p>
                                                        </div>
                                                        <div className='image-overlay position-absolute top-0 end-0 m-2'>
                                                            <a 
                                                                href={selectedPayment.files} 
                                                                target='_blank' 
                                                                rel='noopener noreferrer'
                                                                className='btn btn-light btn-sm shadow-sm'
                                                                title='View Full Size'
                                                            >
                                                                <i className='fas fa-expand-arrows-alt'></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='card-footer bg-white text-center border-top-0'>
                                                    <small className='text-muted'>
                                                        <i className='fas fa-file me-1'></i>
                                                        {selectedPayment.originalFileName || 'payment-proof.jpg'}
                                                    </small>
                                                    <div className='mt-2'>
                                                        <a 
                                                            href={selectedPayment.files} 
                                                            target='_blank' 
                                                            rel='noopener noreferrer'
                                                            className='btn btn-outline-primary btn-sm'
                                                            download
                                                        >
                                                            <i className='fas fa-download me-2'></i>
                                                            Download Image
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='card border-0 shadow-sm border-dashed'>
                                                <div className='card-body text-center py-5'>
                                                    <i className='fas fa-image fa-3x text-muted mb-3 opacity-50'></i>
                                                    <h6 className='text-muted'>No Payment Proof</h6>
                                                    <p className='text-muted small mb-0'>No image was uploaded with this payment</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='modal-footer bg-white border-top sticky-bottom'>
                                <button
                                    type='button'
                                    className='btn btn-secondary'
                                    onClick={() => setShowModal(false)}
                                >
                                    <i className='fas fa-times me-2'></i>
                                    Close
                                </button>
                                
                                {selectedPayment.ispCustomerId && (
                                    <a
                                        href={`${process.env.REACT_APP_BILL_APP_URL}/#/customer-details/${selectedPayment.ispCustomerId}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='btn btn-info'
                                    >
                                        <i className='fas fa-external-link-alt me-2'></i>
                                        Receive ৳{formatAmount(selectedPayment.amount).replace('BDT', '').trim()}
                                    </a>
                                )}
                                
                                {selectedPayment.status === 'created' && (
                                    <button
                                        type='button'
                                        className='btn btn-success'
                                        onClick={() => approvePayment(selectedPayment)}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                Approving...
                                            </>
                                        ) : (
                                            <>
                                                <i className='fas fa-check me-2'></i>
                                                Approve Payment
                                            </>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .bg-pink { background-color: #e91e63 !important; }
                .bg-orange { background-color: #ff9800 !important; }
                .bg-purple { background-color: #9c27b0 !important; }
                .text-truncate {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .modal.show {
                    display: block !important;
                }
                .table-hover tbody tr:hover {
                    background-color: rgba(0, 123, 255, 0.1);
                }
                
                /* Enhanced Modal Styles */
                .modal-adaptive {
                    padding: 0;
                }
                
                .modal-dialog-adaptive {
                    margin: 0;
                    display: flex;
                    flex-direction: column;
                }
                
                .modal-content {
                    display: flex;
                    flex-direction: column;
                    border: 0;
                }
                
                .sticky-top {
                    position: sticky;
                    top: 0;
                    z-index: 1020;
                }
                
                .sticky-bottom {
                    position: sticky;
                    bottom: 0;
                    z-index: 1020;
                }
                
                .modal-body-scrollable {
                    flex: 1;
                    overflow-y: auto;
                    padding-bottom: 2rem;
                }
                
                .info-item {
                    margin-bottom: 1.5rem;
                }
                
                .info-item-inline {
                    margin-bottom: 1rem;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                }
                
                .info-label {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #6c757d;
                    margin-bottom: 0.5rem;
                    display: block;
                }
                
                .info-label-inline {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #6c757d;
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                }
                
                .info-value {
                    font-size: 1rem;
                    color: #212529;
                    font-weight: 500;
                }
                
                .info-value-inline {
                    font-size: 1rem;
                    color: #212529;
                    font-weight: 500;
                    flex: 1;
                    min-width: 0;
                    word-break: break-word;
                }
                
                .notes-inline {
                    background-color: #f8f9fa;
                    padding: 0.5rem 0.75rem;
                    border-radius: 0.375rem;
                    border-left: 3px solid #ffc107;
                    font-style: italic;
                    line-height: 1.5;
                    margin-top: 0.25rem;
                    white-space: pre-wrap;
                }
                
                .notes-content {
                    line-height: 1.6;
                    font-size: 0.95rem;
                }
                
                .payment-image-container {
                    border-radius: 0.375rem;
                    overflow: hidden;
                }
                
                .payment-image {
                    border-radius: 0;
                    transition: transform 0.3s ease;
                    cursor: zoom-in;
                }
                
                .payment-image:hover {
                    transform: scale(1.02);
                }
                
                .image-overlay {
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }
                
                .payment-image-container:hover .image-overlay {
                    opacity: 1;
                }
                
                .border-dashed {
                    border: 2px dashed #dee2e6 !important;
                }
                
                .card-header {
                    border-bottom: 1px solid #e9ecef;
                }
                
                .fs-6 {
                    font-size: 1.125rem !important;
                }
                
                .border-4 {
                    border-width: 4px !important;
                }
                
                /* Mobile Payment Cards */
                .payment-cards {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }
                
                .payment-card {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    transition: all 0.3s ease;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                }
                
                .payment-card:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    transform: translateY(-1px);
                    border-color: #007bff;
                }
                
                .payment-card:active {
                    transform: translateY(0);
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }
                
                .payment-card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.75rem;
                    padding-bottom: 0.75rem;
                    border-bottom: 1px solid #f1f3f4;
                }
                
                .payment-amount {
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: #28a745;
                }
                
                .payment-status .badge {
                    font-size: 0.75rem;
                    padding: 0.375rem 0.75rem;
                }
                
                .payment-card-body {
                    margin-bottom: 0.75rem;
                }
                
                .payment-info-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.5rem;
                    min-height: 1.5rem;
                }
                
                .payment-info-row:last-child {
                    margin-bottom: 0;
                }
                
                .info-label-mobile {
                    font-size: 0.8rem;
                    font-weight: 600;
                    color: #6c757d;
                    flex-shrink: 0;
                    min-width: fit-content;
                }
                
                .info-value-mobile {
                    font-size: 0.85rem;
                    color: #212529;
                    font-weight: 500;
                    text-align: right;
                    flex: 1;
                    margin-left: 0.5rem;
                    word-break: break-word;
                }
                
                .payment-card-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 0.75rem;
                    border-top: 1px solid #f1f3f4;
                }
                
                .payment-date {
                    display: flex;
                    align-items: center;
                    flex: 1;
                }
                
                .payment-action {
                    display: flex;
                    align-items: center;
                }
                
                /* Mobile Search Input */
                .form-control-lg {
                    padding-left: 2.5rem;
                }
                
                /* Mobile responsive adjustments */
                @media (max-width: 576px) {
                    .payment-card {
                        padding: 0.75rem;
                        border-radius: 0.5rem;
                    }
                    
                    .payment-amount {
                        font-size: 1.1rem;
                    }
                    
                    .info-label-mobile {
                        font-size: 0.75rem;
                    }
                    
                    .info-value-mobile {
                        font-size: 0.8rem;
                    }
                    
                    .payment-info-row {
                        margin-bottom: 0.375rem;
                    }
                }
                
                /* Mobile specific styles - Full screen */
                @media (max-width: 768px) {
                    .modal-adaptive {
                        padding: 0;
                    }
                    
                    .modal-dialog-adaptive {
                        width: 100vw;
                        height: 100vh;
                        margin: 0;
                        max-width: none;
                    }
                    
                    .modal-content {
                        height: 100vh;
                        border-radius: 0;
                    }
                    
                    .modal-body-scrollable {
                        padding: 1rem !important;
                        padding-bottom: 2rem !important;
                    }
                    
                    .info-item {
                        margin-bottom: 1rem;
                    }
                    
                    .info-item-inline {
                        margin-bottom: 0.75rem;
                        flex-direction: row;
                        align-items: center;
                        gap: 0.375rem;
                    }
                    
                    .info-label-inline {
                        font-size: 0.8rem;
                        flex-shrink: 0;
                        min-width: fit-content;
                    }
                    
                    .info-value-inline {
                        font-size: 0.9rem;
                        flex: 1;
                        text-align: left;
                    }
                    
                    .notes-inline {
                        font-size: 0.85rem;
                        padding: 0.375rem 0.5rem;
                        margin-top: 0.125rem;
                    }
                    
                    .payment-image {
                        max-height: 250px !important;
                    }
                    
                    .modal-header {
                        padding: 0.75rem 1rem;
                    }
                    
                    .modal-footer {
                        padding: 0.75rem 1rem;
                        flex-wrap: wrap;
                        gap: 0.5rem;
                    }
                    
                    .modal-footer .btn {
                        flex: 1;
                        min-width: auto;
                    }
                }
                
                /* Desktop styles - Large modal */
                @media (min-width: 769px) {
                    .modal-adaptive {
                        padding: 1.75rem;
                    }
                    
                    .modal-dialog-adaptive {
                        max-width: 1200px;
                        width: 90%;
                        margin: 0 auto;
                        height: auto;
                        max-height: 90vh;
                    }
                    
                    .modal-content {
                        border-radius: 0.75rem;
                        box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
                        height: auto;
                        max-height: 90vh;
                    }
                    
                    .modal-body-scrollable {
                        padding: 2rem !important;
                        max-height: calc(90vh - 140px);
                    }
                    
                    .payment-image {
                        max-height: 400px !important;
                    }
                    
                    .modal-header {
                        border-radius: 0.75rem 0.75rem 0 0;
                    }
                    
                    .modal-footer {
                        border-radius: 0 0 0.75rem 0.75rem;
                    }
                }
            `}</style>
        </>
    )
}

export default PaymentList